// extracted by mini-css-extract-plugin
module.exports = {"expert__subtitle":"styles_expert__subtitle__1s4Yk","expert__cardWrapper":"styles_expert__cardWrapper__RBS3q","expert__avatar":"styles_expert__avatar__WwY19"};